import { flatMap } from 'rxjs/operators';
import {
  BaseFormComponent,
  BaseFormHeaderInfo
} from '../../tasks/baseFormComponent/baseForm.component';
import { Component, OnInit, Optional, ElementRef, Input, AfterContentInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';


import { InvoiceDTO, ProjectEntityDTO, ObjectContextDTO } from '../../api/plyca-dtos-v2';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, Observable, of } from 'rxjs';
import { FormConfig } from '../../components/forms/form.objects';

import { generateRandomIdentifier } from '../../ui.service';
import { DocumentFileTypeDTO, FileDetailsDTO, I18nData, TaskDTO } from '../../api/plyca-dtos';
import { PropertyService } from '../../properties/property.service';
import { HelpType } from '../../components/common/help/help.service';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';

export class InvoiceModel {

  dto: InvoiceDTO;
  ui: {

    'contexWork'?: ObjectContextDTO,
    'isElectronicProcedure'?: boolean,
    'showCheckSigner'?: boolean,
    'showDetailLines'?: boolean,
    'showPaymentPlannedTime'?: boolean,
    'showPaymentPlannedTimeDate'?: boolean,
    'showCompanySearch'?: boolean,
    'allowSaveAmount'?: boolean,
    '_files'?: FileDetailsDTO[];
  }
}

@Component({
  selector: 'invoice-form',
  templateUrl: '../../tasks/baseFormComponent/baseForm.template.html'
})
export class InvoiceComponent
  extends BaseFormComponent<InvoiceDTO, InvoiceModel>
  implements OnInit, AfterContentInit, OnDestroy {

  private identifier: string;

  dossierId: any;
  loteId: any;

  @Input()
  project: ProjectEntityDTO;
  projectId: any;
  invoice: any;
  invoiceTask: TaskDTO
  readonly = false;
  accionModal = '';
  contractTotal = 0;
  invoicesTotal = 0;

  constructor(
    elem: ElementRef,
    public translationService: TranslateService,
    public dialogConfig: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private propertyService: PropertyService,
    private plycaErrorHandler: PlycaErrorHandler,
    @Optional() protected activatedRoute: ActivatedRoute

  ) {
    super(elem);
    this.identifier = dialogConfig['id'];
    this.projectId = dialogConfig['projectId'];
    this.loteId = dialogConfig['loteId'];
    this.invoiceTask = dialogConfig['task'];
    this.readonly = dialogConfig['readonly'] ? dialogConfig['readonly'] : false;
    this.accionModal = dialogConfig['accion'];

    this.contractTotal = dialogConfig['contractTotal'];
    this.invoicesTotal = dialogConfig['invoicesTotal'];

    this.windowHash = generateRandomIdentifier();
  }

  ngOnDestroy(): void {
    this.dialogConfig = null;
    this.ref = null;
    super.ngOnDestroy();
  }

  getObjectParams(): { [param: string]: string | string[]; } {
    return {
      expand: 'expansionSet:work',
      projectIdentifier: this.projectId,
      divisionId: this.loteId,
      taskId: this.invoiceTask.identifier,
      invoiceAction: this.accionModal,

    };
  }

  ngAfterContentInit(): void {



  }

  getFormSettingURL(): string {
    return 'invoices/invoiceInterfaceSettings.json';
  }

  getServiceURL(): string {
    return this.configuration.INVOICES_SERVICE_URL;
  }

  getObjectIdentifier(): string {
    return this.identifier;
  }


  dtoToModel(dto: InvoiceDTO): Observable<InvoiceModel> {

    let model = new InvoiceModel();
    // inicializacion de los campos del modelo utilizados por el json

    model.dto = dto;
    if (model.dto.totalAmount) {
      this.invoicesTotal = this.invoicesTotal - model.dto.totalAmount;
    }


    // Iniciamos el ui



    // Iniciamos el ui
    model.ui = {};
    model.ui.isElectronicProcedure = false;
    model.ui.showCheckSigner = false;


    return forkJoin(
      this.propertyService.getProperty('MaterialSolicitadoFactura.MODO_DESGLOSADO', ''),
      this.propertyService.getProperty('VISUALIZA_FACTURA_FECHAPLAZOPAGO', ''),
      this.propertyService.getProperty('VISUALIZA_FACTURA_PLAZOPAGO', ''),
      this.propertyService.getProperty('PERMITIR_SUPERAR_IMPORTE_ADJ', '')
    ).pipe(

      flatMap((result) => {
        model.ui.showDetailLines = (result[0] == 'S' || result[0] == 's');
        model.ui.showPaymentPlannedTimeDate = (result[1] == 'true' || result[1] == 'TRUE');

        model.ui.showPaymentPlannedTime = (result[2] == 'true' || result[2] == 'TRUE');
        model.ui.allowSaveAmount = (result[3] == 'true' || result[3] == 'TRUE');

        this.initDraftFiles(model.dto);
        model.ui._files = [];
        if (dto.document.currentVersion.files) {
          model.ui._files = [].concat(dto.document.currentVersion.files);
        }


        if (this.invoiceTask && this.invoiceTask.work) {
          model.ui.contexWork = this.invoiceTask.work.context;

          model.ui.isElectronicProcedure = (model.ui.contexWork.configurations.isElectronicProcedure
            && model.ui.contexWork.configurations.isElectronicProcedure.value
            && model.ui.contexWork.configurations.isElectronicProcedure.value === true) ? true : false;

          model.ui.showCheckSigner = (
            (!model.ui.contexWork.configurations.needsPromoterSign
              || !model.ui.contexWork.configurations.needsPromoterSign.value
              || model.ui.contexWork.configurations.needsPromoterSign.value === false)
            && (model.dto.context.configurations.needsPromoterSign
              && model.dto.context.configurations.needsPromoterSign.value
              && model.dto.context.configurations.needsPromoterSign.value === true)
          );



        }

        model.ui.showCompanySearch = (model.ui.contexWork.configurations.showCompanySearch
          && model.ui.contexWork.configurations.showCompanySearch.value
          && model.ui.contexWork.configurations.showCompanySearch.value === true) ? true : false;
        // model.ui.showCompanySearch = true;


        if (model.ui.showCompanySearch && this.identifier == 'new') {

          model.dto.company = undefined;
          model.dto.taxIdentifier = undefined;

        }
        return of(model);

      })
    );








  }






  modelToDTO(model: InvoiceModel): InvoiceDTO {
    let dto = new InvoiceDTO();
    dto = model.dto;

    // Eliminar referencias a datos de apoyo a la edicion
    if (model.ui._files && model.ui._files.length > 0) {

      dto.document.currentVersion.files = [].concat(model.ui._files);
    } else {
      dto.document.currentVersion.files = undefined;
    }
    // TODO: Poner para crear facturas seleccionando licitador
    dto.company.type = 'A';
    dto.taxIdentifier = '';
    dto.taxIdentifier = dto.company.taxIdentifier;

    dto = JSON.parse(
      JSON.stringify(dto, (k, v) => (k === '_parent' ? undefined : v))
    );
    return dto;

  }

  getTitle(model: InvoiceDTO): string {

    return 'Invoices.edit.tooltip';
    /*
    if (model) {
      return 'Invoices.edit';
    } else {
      return 'Invoices.add';
    }*/
  }



  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = this.getTitle(this.model.dto);
    headerInfo.titleIcon = 'fas fas fa-file-invoice-dollar';
    if (this.model && this.model.dto.division && this.model.dto.division.project) {
      // headerInfo.project = this.model.division.project;
    }
    // TODO pendiente de extraer datos para nueva comm
    // headerInfo.project = this.model.dto.project;
    return headerInfo;
  }

  initHeaderActions() {

    if (!this.readonly) {
      this.subscribe(this.headerActionsService
        .addWindowAction('General.save', 'fas fa-save', 'btn-primary', true, this.windowHash),

        (() => {
          this.cliente_validation();


        }))
    } else {
      if (this.accionModal === 'RECTIFY') {


        this.subscribe(this.headerActionsService.addWindowAction('Invoices.rectify.text',
          'fas fa-redo-alt', 'btn-warning', true, this.windowHash),
          () => {
            this.uiService.showConfirmMessage({
              message: this.translateService.instant(
                'Invoices.rectify.warning'
              ),
              header: 'Confirmation',
              icon: 'pi pi-exclamation-triangle',
              accept: () => {

                let url = this.configuration.INVOICE_DOCUMENT_EVENT_URL.replace(
                  '{documentIdentifier}',
                  this.model.dto.document.identifier
                );
                url = url.replace(
                  '{eventId}',
                  'RectifyDocument'
                );

                this.subscribe(this.plycaService.simpleUpdate(
                  url,
                  new Object()
                ),
                  (result) => {
                    this.waitService.cancelWaiting();
                    this.ref.close(result);
                  },
                  (error: any) => {
                    this.manageActionError(error, true);


                  }
                )
              },
              reject: () => {
                this.ref.close();
              }
            });
          });
      } else if (this.accionModal === 'REJECT') {

        this.subscribe(this.headerActionsService
          .addWindowAction('Invoices.reject.text', 'fas fa-times', 'btn-danger', true, this.windowHash), () => {
            this.anular();

          });


      } if (this.accionModal === 'IMPORT') {


        this.subscribe(this.headerActionsService.addWindowAction('Invoices.import.text',
          'fas fa-file-import', 'btn-primary',
          true, this.windowHash),
          () => {
            this.uiService.showConfirmMessage({
              message: 'Se va a proceder a crear una nueva factura con el archivo importado.',
              header: 'Confirmation',
              icon: 'pi pi-exclamation-triangle',
              accept: () => {

                let url = this.configuration.INVOICE_DOCUMENT_EVENT_URL.replace(
                  '{documentIdentifier}',
                  this.model.dto.document.identifier
                );
                url = url.replace(
                  '{eventId}',
                  'RectifyDocument'
                );

                this.subscribe(this.plycaService.simpleUpdate(
                  url,
                  new Object()
                ),
                  (result) => {
                    this.waitService.cancelWaiting();
                    this.ref.close(result);
                  },
                  (error: any) => {
                    this.manageActionError(error, true);


                  })
              },
              reject: () => {
                this.ref.close();
              }
            });
          });

      }
    }

  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = true;
    formConfig.isModalWindow = true;
    formConfig.windowHash = this.windowHash;
    formConfig.readonly = this.readonly;
    formConfig.searchTags = [HelpType.FACTURA];

    formConfig.functions.push({
      identifier: 'valueName',
      fn: this.valueName
    });
    return of(formConfig);
  }

  // Valor del campo Directiva de aplicacion
  public valueName(model: any) {
    if (model.dto.company && model.dto.company.commercialName) {
      model.dto.company.name = model.dto.company.commercialName;
      model.dto.taxIdentifier = model.dto.company.taxIdentifier;
    }

  }

  /*  ¿Mover a documentService?*/

  private initDraftFiles(dto): void {

    let tmpDrafFiles: Array<FileDetailsDTO> = [];
    let temporalFiles: Array<FileDetailsDTO> = [];
    if (
      dto != null && dto.document != null &&
      dto.document.currentVersion != null &&
      dto.document.currentVersion.files != null
    ) {
      let allFiles: Array<FileDetailsDTO> = [];
      tmpDrafFiles = this.documentService.getTypeDocument(
        DocumentFileTypeDTO.Draft,
        dto.document
      );
      temporalFiles = this.documentService.getTypeDocument(
        DocumentFileTypeDTO.Temporal,
        dto.document
      );
      allFiles = tmpDrafFiles.concat(temporalFiles);

      dto.document.currentVersion.files = allFiles;
    } else {
      dto.document.currentVersion.files = tmpDrafFiles;
    }

  }

  modalError(error) {
    this.ref.close();
    this.plycaErrorHandler.showServerError(error);
    // this.uiService.showMessage(
    //   error.errors[0].message,
    //   this.translateService.instant('General.error'),
    //   'errorStyle'
    // );
  }

  cliente_validation() {
    let total = this.invoicesTotal + this.model.dto.totalAmount;
    if (!this.model.dto.company || !this.model.dto.company.taxIdentifier) {
      this.uiService.showMessage(new I18nData('Invoices.save.errorcompany'));

    } else if ((this.contractTotal < total)) {


      let confirmmessage = this.translateService.instant('Invoices.save.erroramount')
        + ' ' + (this.invoicesTotal + this.model.dto.totalAmount) + ' > ' + this.contractTotal + '.';


      if (this.model.ui.allowSaveAmount) {


        this.uiService.showConfirmMessage({
          message: confirmmessage,
          header: 'Confirmation',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {

            this.guardar();
          }
        });




      } else {
        this.uiService.showMessage(confirmmessage);

      }





    } else {
      this.guardar();
    }

  }

  guardar() {
    this.subscribe(this.save(),
      (newInvoice: InvoiceDTO) => {
        this.waitService.cancelWaiting();
        this.uiService.showSuccess('La factura se ha actualizado correctamente.', this.translate.instant('General.info'),
          'success');
        this.ref.close(newInvoice);
      })
  }
  /*
         getJTextFieldNumero().setDocument(new LimitarAXCaracteres(getToolkit(), 20));
          getJTextFieldEjercicio().setDocument(new LimitarAXNumeros(getToolkit(), 4));
          getJTextFieldNumFactRectificacion().setDocument(new LimitarAXCaracteres(getToolkit(), 20));
          getJTextAreaMotivoRectificacion().setDocument(new LimitarAXCaracteres(getToolkit(), 3000));
          String caracteresNumFactura = JACSilice.getProperty("FraExpedienteF.numfactura.limite");
  */
  anular() {


    if (this.model.dto.relatedAccountingDocs && this.model.dto.relatedAccountingDocs.length > 0) {

      this.uiService.showMessage(new I18nData(
        'Invoices.reject.errormessage'
      ))
    } else {
      this.uiService.showConfirmMessage({
        message: this.translateService.instant(
          'Invoices.reject.warning'
        ),
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          // Calcular el estado anulado
          /*
             if (factura.getCodigoExterno() == null || factura.getCodigoExterno().trim().equals("")) {
                  estado = GestGasto.ANULADO;
              } else {
                  estado = estadoPreanulado;
              }
          */
          let newStateEvent = '';
          if (this.model.dto.externalCode) {
            newStateEvent = 'PreCancelDocument';
          } else {
            newStateEvent = 'CancelDocument';
          }


          let url = this.configuration.INVOICE_DOCUMENT_EVENT_URL.replace(
            '{documentIdentifier}',
            this.model.dto.document.identifier
          );
          url = url.replace(
            '{eventId}',
            newStateEvent
          );

          this.subscribe(this.plycaService.simpleUpdate(
            url,
            new Object()
          ),
            (result) => {
              this.waitService.cancelWaiting();
              this.ref.close(result);
            },
            (error: any) => {
              this.manageActionError(error, true);


            })
        },
        reject: () => {
          this.ref.close();
        }
      });
    }


  }
}
